// extracted by mini-css-extract-plugin
export default {"container":"consent-reminder-notification_container__cfeDM","buttonRow":"consent-reminder-notification_buttonRow__B8rf+"};